import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './component/Navbar';
import Hero from './component/Hero';
import TrustLogos from './component/TrustLogos';
import AboutSection from './component/AboutSection';
import ServicesSection from './component/ServicesSection';
import ProductsSection from './component/ProductsSection';
import IndustriesSection from './component/IndustriesSection';
import WhyChooseUs from './component/WhyChooseUs';
import TechStack from './component/TechStack';
import ProcessTimeline from './component/ProcessTimeline';
import CaseStudies from './component/CaseStudies';
import Testimonials from './component/Testimonials';
import BlogSection from './component/BlogSection';
import CareersSection from './component/CareersSection';
import ContactSection from './component/ContactSection';
import Footer from './component/Footer';
import ConsultationModal from './component/ConsultationModal';

const HomePage = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);
  const [initialProduct, setInitialProduct] = useState('');
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.replace('/', '');
    if (path) {
      const el = document.getElementById(path);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth' });
        }, 150);
      }
    } else if (!location.hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location.pathname, location.hash]);

  const handleOpenConsultation = () => {
    setInitialProduct('');
    setIsConsultationOpen(true);
  };

  const handleRequestDemo = (productName) => {
    setInitialProduct(productName);
    setIsConsultationOpen(true);
  };

  return (
    <div style={{ backgroundColor: '#060816', color: '#FFFFFF', minHeight: '100vh', position: 'relative' }}>
      {/* Navigation Header */}
      <Navbar onOpenConsultation={handleOpenConsultation} />

      {/* Main Sections */}
      <main>
        <Hero onOpenConsultation={handleOpenConsultation} />
        <TrustLogos />
        <AboutSection />
        <ServicesSection onOpenConsultation={handleOpenConsultation} />
        <ProductsSection onOpenConsultation={handleOpenConsultation} onRequestDemo={handleRequestDemo} />
        <IndustriesSection />
        <WhyChooseUs />
        <TechStack />
        <ProcessTimeline />
        <CaseStudies onOpenConsultation={handleOpenConsultation} />
        <Testimonials />
        <BlogSection />
        <CareersSection onOpenConsultation={handleOpenConsultation} />
        <ContactSection onOpenConsultation={handleOpenConsultation} />
      </main>

      {/* Footer */}
      <Footer />

      {/* Interactive Booking & Consultation Modal */}
      <ConsultationModal
        isOpen={isConsultationOpen}
        onClose={() => setIsConsultationOpen(false)}
        initialProduct={initialProduct}
      />
    </div>
  );
};

export default HomePage;
